import { render } from "./DataTableAsync.vue?vue&type=template&id=6846c72d&scoped=true"
import script from "./DataTableAsync.vue?vue&type=script&lang=js"
export * from "./DataTableAsync.vue?vue&type=script&lang=js"

import "./DataTableAsync.vue?vue&type=style&index=0&id=6846c72d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6846c72d"]])

export default __exports__